/* eslint-disable react/prop-types */
/* eslint-disable prefer-destructuring */

import { FC, forwardRef } from 'react';
import { CarouselPropTypes } from './types/propTypes';
import { GUTTER_SIZE } from './types/enums';
import InfiniteCarousel from './InfiniteCarousel';
import DefaultCarousel from './DefaultCarousel';

// Carousel Component
const Carousel: FC<CarouselPropTypes> = forwardRef<HTMLDivElement | undefined, CarouselPropTypes>(
  ({ isInfiniteScroll = false, ...restProp }, ref) =>
    isInfiniteScroll ? (
      <InfiniteCarousel {...restProp} forwardedRef={ref} />
    ) : (
      <DefaultCarousel {...restProp} forwardedRef={ref} />
    ),
);
Carousel.displayName = 'Carousel';
export default Carousel;
export type { CarouselPropTypes, GUTTER_SIZE };
